import React from "react";
import TryThisOut from "../pages/tryNow/TryThisOut";

function EmiratesIdOCR({ currentProduct, mode }) {
  return (
    <>
      <TryThisOut currentProduct={currentProduct} mode={mode} />
    </>
  );
}

export default EmiratesIdOCR;
